import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StorageDeleteLinksModal from './StorageDeleteLinksModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  storage: state.storage,
  status: state.modal.storageDeleteLinksModal.status,
  id: state.modal.storageDeleteLinksModal.id,
  list: state.modal.storageDeleteLinksModal.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_DELETE_LINKS, { status: false, id: null, list: [] }),
  deleteStorageAssignmentByArray: actions.storage.deleteStorageAssignmentByArray,
  deleteStorageByArray: actions.storage.deleteStorageByArray,
  updateTable: actions.channel.updateTable
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageDeleteLinksModal)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageDeleteLinksModal/index.js